<template>
    <div class="pop" @click.self="close">
      <div class="info">
        <div class="title">05地块土壤湿度传感器</div>
        <div class="topinfo">
          <img src="@/assets/agr-sertvice-icon.png" class="img" />
          <div class="rightinfo">
            <span class="name"
              ><img src="@/assets/building-icon.png" class="icon" />
              中牟县</span
            >
            <span class="date">六十鱼 15838814218</span>
          </div>
        </div>
        <div class="listinfo">
          <span class="leftname">
            <img src="@/assets/area-icon.png" class="icon" />
            地块面积</span
          ><span>51亩</span>
        </div>
        <div class="listinfo">
          <span class="leftname"
            ><img
              src="@/assets/variety-icon.png"
              class="icon"
            />种养品种</span
          ><span>小麦·洛麦47</span>
        </div>
        <div class="listinfo">
          <span class="leftname"
            ><img src="@/assets/date-icon.png" class="icon" />种植时间</span
          ><span>2025-02-01</span>
        </div>
        <div class="btn" @click.stop="openDetail">查看详情</div>
      </div>
    </div>
</template>
<script setup>
import { defineEmits, onMounted } from "vue";
const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
onMounted(() => {});
</script>
<style lang="scss" scoped>
.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0.6);
  .info {
    width: 300px;
    height: 358px;
    background: url(@/assets/Suspended_Window.png) 100%;
    position: absolute;
    right: 381px;
    top: 191px;
    display: flex;
    flex-direction: column;
    padding: 10px 25px;
    box-sizing: border-box;
    .title {
      line-height: 31px;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
    }
    .topinfo {
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      margin: 25px 0 12px;
      gap: 10px;
      .img {
        width: 70px;
        height: 70px;
      }
      .rightinfo {
        width: 171px;
        height: 70px;
        background: rgba(226, 255, 218, 0.1);
        box-shadow: 2px 4px 4px 0px rgba(7, 56, 21, 0.25);
        border-radius: 8px;
        padding: 11px 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 4px;
        .name {
          line-height: 21px;
          color: #41fe79;
          font-size: 16px;
          display: flex;
          align-items: center;
          gap: 6px;
          .icon {
            width: 14px;
            height: 18px;
          }
        }
        .date {
          line-height: 16px;
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .listinfo {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      width: 249px;
      border-bottom: 1px solid;
      border-image: linear-gradient(
          90deg,
          rgba(64, 196, 93, 0.28),
          rgba(0, 255, 47, 1),
          rgba(255, 255, 255, 1),
          rgba(0, 255, 77, 1),
          rgba(31, 138, 63, 0.2)
        )
        1 1;
      .leftname {
        display: flex;
        align-items: center;
        gap: 4px;
        .icon {
          width: 18px;
          height: 18px;
        }
      }
    }
    .btn {
      width: 110px;
      height: 33px;
      line-height: 33px;
      text-align: center;
      background-image: url(@/assets/btn-bg.png);
      color: #fff;
      font-family: "YouSheBiaoTiHei";
      margin: 20px auto;
      cursor: pointer;
    }
  }
}
</style>